// extracted by mini-css-extract-plugin
export var notificationHost = "_eh-0";